import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';

const styles = {
  footer: { backgroundColor: colors.neutral[800] },
  footerContent: {
    maxWidth: '170rem',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '2rem',
    [breakpoints.md.down]: {
      flexDirection: 'column',
    },
  },
  copyright: {
    color: colors.neutral.white,
    fontSize: '1.4rem',
    lineHeight: '2rem',
    textAlign: 'center',
  },
  links: {
    display: 'flex',
    gap: '2rem',
    alignItems: 'center',
    listStyle: 'none',
    paddingLeft: 0,
  },
  linkItem: {
    '&:first-child': {
      paddingRight: '2rem',
      borderRight: `0.1rem solid ${colors.neutral[600]}`,
    },
    '& a': {
      color: colors.orange[600],
      fontSize: '1.6rem',
      lineHeight: '2.4rem',
      letterSpacing: '0.02em',
    },
    '& a:hover': {
      color: colors.neutral.white,
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
